import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { BaryModalForm } from '../../../../../../../../models/bary-modal-form';
import { BaryComponentHelper } from '../../../../../../util/bary-component-helper';
import { IBaryModalEvent } from '../../../../../../../../models/bary-modal-event';
import { EventManager } from '../../../../../../../../services/event-manager.service';

import { MDBModalRef } from 'ng-uikit-pro-standard';
import { TransportView } from '../../../../../../../../models/transport-view.model';
import { TransportService } from '../../../../../../../../services/transport.service';
import { Transport } from '../../../../../../../../models/transport.model';
import { TransportExtendedService } from '../../../../../../../../services/transport-extended.service';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, tap } from 'rxjs/operators';
import { TransportCardComponent } from '../../../../../transport-card/transport-card.component';
import { BaryButtonComponent } from '../../../../../../components';
import { AsyncPipe, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateDirective } from '../../../../../../../../directives/translate.directive';

@Component({
  templateUrl: './popin-detail-transport.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TransportCardComponent, TranslateModule, BaryButtonComponent, TranslateDirective, AsyncPipe, NgIf],
})
export class PopinDetailTransportComponent extends BaryModalForm implements OnInit {
  readonly #modalRef = inject(MDBModalRef);
  readonly #transportService = inject(TransportExtendedService);
  readonly #spinnerService = inject(NgxSpinnerService);

  public override action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public transportView!: TransportView;

  public customerId!: number;
  public transportId!: number;
  public transport$!: Observable<Transport>;

  public ngOnInit(): void {
    this.transport$ = this.#transportService.getByIdAndCustomerId(this.transportView.id!, this.transportView.customerId!).pipe(
      tap(() => this.#spinnerService.show()),
      finalize(() => this.#spinnerService.hide())
    );
  }
  public handleClick(event: IBaryModalEvent): void {
    this.action.next(event);
    this.#modalRef.hide();
  }
}
